import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-db9d9ade")

_pushScopeId("data-v-db9d9ade")
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "subtitle has-text-weight-bold" }
const _hoisted_5 = {
  class: "has-text-centered fontsize110",
  "data-testid": "ctf-text-user-not-registered"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" You should register to this CTF before accessing the registered members. ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "has-text-weight-bold fontsize125"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" members are curently registered. ")
const _hoisted_12 = { class: "is-flex is-justify-content-center" }
const _hoisted_13 = { class: "is-small has-text-centered" }
const _hoisted_14 = { class: "fontsize145" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "fontsize75" }, [
  /*#__PURE__*/_createTextVNode(" Register to access teammate profiles "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" and start chatting with others ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "modal-background transparent"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "subtitle has-text-weight-bold" }
const _hoisted_21 = { class: "is-right" }
const _hoisted_22 = {
  key: 2,
  class: "columns is-multiline mt-3"
}
const _hoisted_23 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_24 = { class: "modal-card" }
const _hoisted_25 = { class: "modal-card-head" }
const _hoisted_26 = { class: "modal-card-title" }
const _hoisted_27 = { class: "modal-card-body" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "modal-card-foot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_popup = _resolveComponent("popup")
  const _component_own_profile_card = _resolveComponent("own-profile-card")
  const _component_profile_card = _resolveComponent("profile-card")

  return (_ctx.data && _ctx.data.findCtf)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.isRegistered == false)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.data.findCtf[0].title), 1),
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  (_ctx.result && _ctx.result.usersInCtfLength)
                    ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.result.usersInCtfLength), 1))
                    : _createCommentVNode("", true),
                  _hoisted_11
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", {
                    class: "is-flex is-flex-direction-column is-align-items-center register popup",
                    style: {
              width: _ctx.windowWidth <= 768 ? '80%' : '30%'
            }
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("p", _hoisted_14, "Hello, " + _toDisplayString(_ctx.user.username), 1),
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _createVNode("button", {
                      class: "button is-link registerbutton",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args))),
                      "data-testid": "ctf-register-button"
                    }, " Register "),
                    _createVNode(_component_popup, {
                      position: "bottom",
                      offsetY: 10,
                      step: 1,
                      showPopup: _ctx.currentStep == 1,
                      onPrevAction: _ctx.prevAction,
                      onNextAction: _ctx.nextAction
                    }, null, 8, ["showPopup", "onPrevAction", "onNextAction"]),
                    (_ctx.currentStep == 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_18))
                      : _createCommentVNode("", true)
                  ], 4)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, _toDisplayString(_ctx.data.findCtf[0].title), 1),
                _createVNode("div", _hoisted_21, [
                  _createVNode("button", {
                    class: "button is-primary is-right is-outlined",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unregister && _ctx.unregister(...args))),
                    "data-testid": "ctf-unregister-button"
                  }, " Unregister ")
                ]),
                _createVNode("a", {
                  href: _ctx.data.findCtf[0].url,
                  target: "_blank"
                }, _toDisplayString(_ctx.data.findCtf[0].url), 9, ["href"])
              ])),
          (_ctx.isRegistered)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableProfiles, ({
            id,
            username,
            level,
            description,
            hashedUsername,
            language,
            skills
          }, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: id,
                    id: `scrollTo-${index}`,
                    class: "column is-one-third popup",
                    style: {
            zIndex:
              (username == _ctx.ownUsername && _ctx.currentStep == 2) ||
              (index == 1 && _ctx.currentStep == 3)
                ? 1
                : 0
          }
                  }, [
                    (username == _ctx.ownUsername)
                      ? (_openBlock(), _createBlock(_component_own_profile_card, {
                          key: 0,
                          "data-testid": "own-profile-card",
                          id: id,
                          username: username,
                          hashedUsername: hashedUsername,
                          level: level,
                          description: description,
                          language: language,
                          skills: skills,
                          tagLoading: _ctx.tagLoading,
                          tag: _ctx.tagResult.findTags
                        }, null, 8, ["id", "username", "hashedUsername", "level", "description", "language", "skills", "tagLoading", "tag"]))
                      : (_openBlock(), _createBlock(_component_profile_card, {
                          key: 1,
                          "data-testid": "profile-card",
                          id: id,
                          index: index,
                          username: username,
                          hashedUsername: hashedUsername,
                          level: level,
                          description: description,
                          language: language,
                          skills: skills,
                          tagLoading: _ctx.tagLoading,
                          tag: _ctx.tagResult.findTags,
                          onSendMessage: _ctx.onSendMessage
                        }, null, 8, ["id", "index", "username", "hashedUsername", "level", "description", "language", "skills", "tagLoading", "tag", "onSendMessage"])),
                    (username == _ctx.ownUsername)
                      ? (_openBlock(), _createBlock(_component_popup, {
                          key: 2,
                          position: "bottom",
                          step: 2,
                          offsetY: -5,
                          showPopup: _ctx.currentStep == 2,
                          onPrevAction: _ctx.prevAction,
                          onNextAction: _ctx.nextAction
                        }, null, 8, ["showPopup", "onPrevAction", "onNextAction"]))
                      : _createCommentVNode("", true),
                    (index == 1)
                      ? (_openBlock(), _createBlock(_component_popup, {
                          key: 3,
                          position: "bottom",
                          step: 3,
                          offsetY: -5,
                          offsetArrow: 40,
                          fixedX: '35px',
                          showPopup: _ctx.currentStep == 3,
                          onPrevAction: _ctx.prevAction,
                          onNextAction: _ctx.nextAction
                        }, null, 8, ["showPopup", "onPrevAction", "onNextAction"]))
                      : _createCommentVNode("", true)
                  ], 12, ["id"]))
                }), 128)),
                (_ctx.currentStep != null)
                  ? (_openBlock(), _createBlock("div", _hoisted_23))
                  : _createCommentVNode("", true),
                _createVNode("div", {
                  class: `modal ${_ctx.isSendMessageOpen ? 'is-active' : ''}`
                }, [
                  (_ctx.sendMessageTo !== null)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "modal-background",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSendMessageOpen = false))
                      }))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: `modal ${_ctx.isSendMessageOpen ? 'is-active' : ''}`
                  }, [
                    (_ctx.sendMessageTo !== null)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "modal-background",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSendMessageOpen = false))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_24, [
                      _createVNode("header", _hoisted_25, [
                        _createVNode("p", _hoisted_26, "Message to " + _toDisplayString(_ctx.sendMessageTo), 1),
                        _createVNode("button", {
                          class: "delete",
                          "aria-label": "close",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSendMessageOpen = false))
                        })
                      ]),
                      _createVNode("section", _hoisted_27, [
                        _createVNode("div", _hoisted_28, [
                          _createVNode("div", _hoisted_29, [
                            _withDirectives(_createVNode("textarea", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.textToSend = $event)),
                              class: "textarea",
                              placeholder: "Hey! I'm looking for a team mate for...",
                              "data-testid": "ctf-modal-textarea"
                            }, null, 512), [
                              [_vModelText, _ctx.textToSend]
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("footer", _hoisted_30, [
                        _createVNode("button", {
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                          class: "button is-success",
                          "data-testid": "ctf-modal-send-button"
                        }, " Send "),
                        _createVNode("button", {
                          class: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isSendMessageOpen = false))
                        }, " Cancel ")
                      ])
                    ])
                  ], 2)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
})